<template>
<div :class="['flowLeftPart',{'showButtonType':showButton, 'hideInnerBox':true}]">
    <div class="leftList stepsList" v-show="useNavStep">
        <nav-step></nav-step>
    </div>
    <!-- <div class="leftList">
        <div :class="[{'activeClass':index==stepIndex},'stepBox']" 
            v-for="(item,index) in leftStepArr" 
            v-show="!('show' in item)||item.show" 
            :key="index" 
            @click="$emit('leftItemClick',index)">
            {{item.name||item.IMG_CLS_NAME}}
            <span class = 'stepIcon' v-show = "getStepstate(item) == 'success'"><i class = 'el-icon-document-success' /></span>
            <span class = 'stepIcon' v-show = "getStepstate(item) == 'reject'"><i class = 'el-icon-document-reject' /></span>
        </div>
    </div> -->
    <!-- <div class="buttonBox">
        <el-button ref = 'rebackBtn' v-show = 'showButton' :options = "{buttonGroup:[{text:'返回列表',value:'reback',handler:()=> {$emit('tack-click')}}]}" />
        <el-button ref = 'jumpOverBtn' v-show = 'showJumpButton' :options = "{buttonGroup:[{text:'跳过',value:'jumpover',handler:()=> {$emit('jump-click')}}]}" />
    </div> -->
    <!-- <div v-show="showCustomizeButton" class="customize-img-button-box" @click="customizeClick">
        <div class="customize-img-icon"></div>
        <div class="customize-img-content">添加自定义影像</div>
    </div> -->
</div>
</template>

<script>
import navStep from "./navStep.vue";

export default {
  data () {
    return {
      showButton: false
    };
  },
  components: {
    navStep
  },
  computed: {
    useNavStep () {
      return this.$route.meta.useNavStep; 
    },
  },
  watch:{
    // leftButtonText:{
    //   handler (newV, oldV) {
    //     this.$nextTick(() => {
    //       newV && this.$refs.rebackBtn.button("changeBtnText","reback",newV);
    //     });
    //   },
    //   deep:true,
    //   immediate:true
    // },
    leftStepArr:{
      handler (newArr, oldArr) {
        // this.$nextTick(() => {
        //   this.$refs.rebackBtn.button("setEnabled","reback");
        //   if(_.find(newArr, obj=> obj.upstatus != "success" && !_.has(obj,"value"))) {
        //     this.$refs.rebackBtn.button("setDisabled","reback");
        //   }
        // });
      },
      deep:true,
      immediate:true
    }
  },
  props: [],
  methods: {
    // getStepstate (item){
    //   if(item.upstatus){
    //     return item.upstatus;
    //   }else if(item.IMG_CLS){
    //     return this.stepState[item.IMG_CLS].upstatus;
    //   }
    // },
    // customizeClick () {
    //   this.$store.commit(this.$types.UPDATE_LEFT_CUSTOMIZE_CLICK, "imgCustomizeClick");
    // }
  },
};
</script>

<style lang="less" scoped>
.flowLeftPart{
    display: flex;
    position: relative;
    width: 300px;
    flex: 0 0 3rem;
    // margin-left: 56px;
    height: 100%;
    box-shadow: 1px 0px 0px rgba(0, 0, 0, 0.08);
    background: #E9EBEE;
    &.hideInnerBox {
        position: relative;
        // width: 84px;
        .leftList:not(.stepsList) {
            display: none;
        }
        .buttonBox {
            flex-direction: column;
            left: 0;
            right: 0;
            margin: 0;
            .kui-button {
                /deep/ .el-button {
                    min-width: 72px;
                    padding: 0 4px;
                }
                &+.kui-button {
                    margin-top: 10px;
                }
            }
        }
        .customize-img-button-box {
            width: 72px;
            left: 1px;
            margin: 0;
            padding: 0 5px;
            .customize-img-content {
                font-size: 14px;
            }
        }
    }
    .leftList{
        width: 100%;
        height: 100%;
        background: #fff;
        overflow-x: hidden;
        position:relative;
        &.stepsList {
          // width: 84px;
        //   padding-top: 5px;
          box-sizing: border-box;
          box-shadow: none;
          background: #E9EBEE;
        }
        .stepBox{
            margin: 0 8px;
            padding: 8px 10px;
            background-color: #FFFFFF;
            border-bottom: 1px solid #f0f0f0;
            font-size: 16px;
            line-height:44px;
            color: #333;
            font-family:"PingFangSC-Regular" !important;
            margin-top: 16px;
            margin-bottom: -10px;
            text-align: left;
            position: relative;
            .stepIcon{
                width: 24px;
                height: 24px;
                position: absolute;
                right: -3px;
                top:50%;
                margin-top:-12px;
                display: flex;
                font-size: 22px;
                align-items: center;
                color: #c52522;
                .el-icon-document-success {
                    width: 100%;
                    height: 100%;
                    display:inline-block;
                    // background-image:url('../../icons/red-theme/step/icon-menu-finish.svg');
                    background-repeat: no-repeat;
                    background-size: contain;

                }
                .el-icon-document-reject {
                    width: 100%;
                    height: 100%;
                    display:inline-block;
                    // background-image:url('../../icons/red/step/icon-frame-warning.svg');
                    background-repeat: no-repeat;
                    background-size: contain;
                }
            }
        }
        .stepBox.activeClass{
            background-image: linear-gradient(90deg,#ffe2dd 0%,#ffefef 100%);
            border-radius: 3px;
            color:#222;
            font-family:"PingFangSC-Medium" !important;
            font-weight: 600;
            .stepIcon{
                 .el-icon-document-success {
                    background-image: none;
                 }
            }
        }    
    }
    .buttonBox{
        display: flex;
        position: absolute;
        left: 50%;
        bottom: 45px;
        margin-left: -80px;
        width: 100%;
        text-align: center;
        justify-content: center;
        .kui-button{
            justify-content: center;
        } 
    }
    .customize-img-button-box {
        width: 180px;
        height: 40px;
        background-color: #fff;
        box-shadow: 0px 2px 16px rgba(167, 167, 167, 0.24);
        position: absolute;
        bottom: 50px;
        left: 50%;
        margin-left: -90px;
        display: flex;
        justify-content: center;
        align-items: center;
        .customize-img-icon {
            width: 16px;
            height: 16px;
            background-size: 100% 100%;
            margin-right: 6px;
        }
        .customize-img-content {
            color: #c52727;
            font-size: 17px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/bizflowLeft.vue